// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N_U-","questions":"styles_questions__qphMA","footer":"styles_footer__1Ayh2"};